import { Link, ProductParagraph, Spacing } from '@issuu/silkscreen';
import format from 'date-fns/format';
import formatDistance from 'date-fns/formatDistanceStrict';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import * as React from 'react';
import styled from 'styled-components';
import { Cover } from './Cover';
const formatDateDistance = (date) => formatDistance(parseISO(date), new Date(), { addSuffix: true });
const formatDate = (date) => format(parseISO(date), 'MMM. d, yyyy');
const isValidDate = (date) => isValid(parseISO(date));
const Root = styled.div `
    display: flex;
`;
const MetaDataWrapper = styled.div `
    min-width: 0;
`;
const CoverWrapper = styled.a `
    min-width: 150px;
    width: 50%;
    margin-right: 12px;
`;
const PublisherBlock = styled.div `
    > p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;
const Publication = ({ coverUrl, pageRange, publishDate, publisherDisplayName, publisherProfileUrl, onPublicationClicked, onPublisherClicked, title, readUrl, }) => {
    return (React.createElement(Root, { style: { pointerEvents: 'all' } },
        React.createElement(CoverWrapper, { "aria-label": `${title} by ${publisherDisplayName}`, href: readUrl, onClick: onPublicationClicked, tabIndex: 0, title: title },
            React.createElement(Cover, { imageUrl: coverUrl, title: title })),
        React.createElement(MetaDataWrapper, null,
            pageRange && React.createElement(ProductParagraph, { step: "negative-2" },
                "pg ",
                pageRange),
            React.createElement(ProductParagraph, null,
                React.createElement(Link, { href: readUrl, onClick: onPublicationClicked }, title)),
            publisherDisplayName && (React.createElement(Spacing, { top: 2 },
                React.createElement(PublisherBlock, null,
                    React.createElement(ProductParagraph, { step: "negative-2" },
                        "by",
                        ' ',
                        React.createElement(Link, { href: publisherProfileUrl, onClick: onPublisherClicked }, publisherDisplayName))))),
            publishDate && isValidDate(publishDate) && (React.createElement(ProductParagraph, { step: "negative-2" },
                "Published",
                ' ',
                React.createElement("time", { dateTime: publishDate, title: formatDate(publishDate) }, formatDateDistance(publishDate)))))));
};
export default Publication;
//# sourceMappingURL=Publication.js.map